import React from "react";
import {Grid} from "@mantine/core";
import {TOC} from "../../../components/TableOfContent";
import {useMediaQuery} from "@mantine/hooks";
import TOCDropdown from "./TOCDropdown";
import CommentSection from "./CommentSection";



interface BlogShellProps {
    entry: React.ReactElement;
    ids: {
        label: string;
        id: string;
        order: number;
    }[];
    rightElement?: React.ReactElement;
    entry_id : string;
}


export function BlogShell({entry, ids, rightElement, entry_id}: BlogShellProps) {
    const isMobile = useMediaQuery('(max-width: 769px)');
    return (
        <Grid>
            <Grid.Col xs={12} sm={3}>
                {
                    !isMobile ? <TOC links={ids} onChange={null} />: <TOCDropdown ids={ids}/>
                }

            </Grid.Col>
            <Grid.Col xs={12} sm={9} md={7}>
                {entry}
                <CommentSection entry_id={entry_id}/>
            </Grid.Col>
            {
                !isMobile ?
                <Grid.Col md={2}>
                    {rightElement}
                </Grid.Col> : null
            }
        </Grid>
    );
}
